/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { remoteMcpCreateServer } from "../funcs/remoteMcpCreateServer.js";
import { remoteMcpCreateServerAndMcpServer } from "../funcs/remoteMcpCreateServerAndMcpServer.js";
import { remoteMcpCreateServerHeader } from "../funcs/remoteMcpCreateServerHeader.js";
import { remoteMcpDeleteServer } from "../funcs/remoteMcpDeleteServer.js";
import { remoteMcpDeleteServerHeader } from "../funcs/remoteMcpDeleteServerHeader.js";
import { remoteMcpDiscoverProtectedResourceMetadata } from "../funcs/remoteMcpDiscoverProtectedResourceMetadata.js";
import { remoteMcpGetServer } from "../funcs/remoteMcpGetServer.js";
import { remoteMcpGetServerHeader } from "../funcs/remoteMcpGetServerHeader.js";
import { remoteMcpGetServerScopes } from "../funcs/remoteMcpGetServerScopes.js";
import { remoteMcpListServerHeaders } from "../funcs/remoteMcpListServerHeaders.js";
import { remoteMcpListServers } from "../funcs/remoteMcpListServers.js";
import { remoteMcpProbeURL } from "../funcs/remoteMcpProbeURL.js";
import { remoteMcpSetServerScopePin } from "../funcs/remoteMcpSetServerScopePin.js";
import { remoteMcpUpdateServer } from "../funcs/remoteMcpUpdateServer.js";
import { remoteMcpUpdateServerHeader } from "../funcs/remoteMcpUpdateServerHeader.js";
import { remoteMcpVerifyURL } from "../funcs/remoteMcpVerifyURL.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateServerAndMcpServerResult } from "../models/components/createserverandmcpserverresult.js";
import { ListServerHeadersResult } from "../models/components/listserverheadersresult.js";
import { ListServersResult } from "../models/components/listserversresult.js";
import { ProbeURLResult } from "../models/components/probeurlresult.js";
import { ProtectedResourceMetadataDiscovery } from "../models/components/protectedresourcemetadatadiscovery.js";
import { RemoteMcpServer } from "../models/components/remotemcpserver.js";
import { RemoteMcpServerHeader } from "../models/components/remotemcpserverheader.js";
import { RemoteMcpServerScopes } from "../models/components/remotemcpserverscopes.js";
import { VerifyURLResult } from "../models/components/verifyurlresult.js";
import {
  CreateRemoteMcpServerRequest,
  CreateRemoteMcpServerSecurity,
} from "../models/operations/createremotemcpserver.js";
import {
  CreateRemoteMcpServerAndMcpServerRequest,
  CreateRemoteMcpServerAndMcpServerSecurity,
} from "../models/operations/createremotemcpserverandmcpserver.js";
import {
  CreateRemoteMcpServerHeaderRequest,
  CreateRemoteMcpServerHeaderSecurity,
} from "../models/operations/createremotemcpserverheader.js";
import {
  DeleteRemoteMcpServerRequest,
  DeleteRemoteMcpServerSecurity,
} from "../models/operations/deleteremotemcpserver.js";
import {
  DeleteRemoteMcpServerHeaderRequest,
  DeleteRemoteMcpServerHeaderSecurity,
} from "../models/operations/deleteremotemcpserverheader.js";
import {
  DiscoverRemoteMcpProtectedResourceMetadataRequest,
  DiscoverRemoteMcpProtectedResourceMetadataSecurity,
} from "../models/operations/discoverremotemcpprotectedresourcemetadata.js";
import {
  GetRemoteMcpServerRequest,
  GetRemoteMcpServerSecurity,
} from "../models/operations/getremotemcpserver.js";
import {
  GetRemoteMcpServerHeaderRequest,
  GetRemoteMcpServerHeaderSecurity,
} from "../models/operations/getremotemcpserverheader.js";
import {
  GetRemoteMcpServerScopesRequest,
  GetRemoteMcpServerScopesSecurity,
} from "../models/operations/getremotemcpserverscopes.js";
import {
  ListRemoteMcpServerHeadersRequest,
  ListRemoteMcpServerHeadersSecurity,
} from "../models/operations/listremotemcpserverheaders.js";
import {
  ListRemoteMcpServersRequest,
  ListRemoteMcpServersSecurity,
} from "../models/operations/listremotemcpservers.js";
import {
  ProbeRemoteMcpURLRequest,
  ProbeRemoteMcpURLSecurity,
} from "../models/operations/proberemotemcpurl.js";
import {
  SetRemoteMcpServerScopePinRequest,
  SetRemoteMcpServerScopePinSecurity,
} from "../models/operations/setremotemcpserverscopepin.js";
import {
  UpdateRemoteMcpServerRequest,
  UpdateRemoteMcpServerSecurity,
} from "../models/operations/updateremotemcpserver.js";
import {
  UpdateRemoteMcpServerHeaderRequest,
  UpdateRemoteMcpServerHeaderSecurity,
} from "../models/operations/updateremotemcpserverheader.js";
import {
  VerifyRemoteMcpURLRequest,
  VerifyRemoteMcpURLSecurity,
} from "../models/operations/verifyremotemcpurl.js";
import { unwrapAsync } from "../types/fp.js";

export class RemoteMcp extends ClientSDK {
  /**
   * createServer remoteMcp
   *
   * @remarks
   * Create a new remote MCP server
   */
  async createServer(
    request: CreateRemoteMcpServerRequest,
    security?: CreateRemoteMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServer> {
    return unwrapAsync(remoteMcpCreateServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createServerAndMcpServer remoteMcp
   *
   * @remarks
   * Create a remote MCP server and its linked, disabled MCP server atomically. The dashboard uses this workflow so a failed linked-server creation never leaves an orphan remote source.
   */
  async createServerAndMcpServer(
    request: CreateRemoteMcpServerAndMcpServerRequest,
    security?: CreateRemoteMcpServerAndMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CreateServerAndMcpServerResult> {
    return unwrapAsync(remoteMcpCreateServerAndMcpServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createServerHeader remoteMcp
   *
   * @remarks
   * Create a header on a remote MCP server
   */
  async createServerHeader(
    request: CreateRemoteMcpServerHeaderRequest,
    security?: CreateRemoteMcpServerHeaderSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServerHeader> {
    return unwrapAsync(remoteMcpCreateServerHeader(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteServer remoteMcp
   *
   * @remarks
   * Delete a remote MCP server
   */
  async deleteServer(
    request: DeleteRemoteMcpServerRequest,
    security?: DeleteRemoteMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(remoteMcpDeleteServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteServerHeader remoteMcp
   *
   * @remarks
   * Delete a remote MCP server header
   */
  async deleteServerHeader(
    request: DeleteRemoteMcpServerHeaderRequest,
    security?: DeleteRemoteMcpServerHeaderSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(remoteMcpDeleteServerHeader(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * discoverProtectedResourceMetadata remoteMcp
   *
   * @remarks
   * Probe the remote MCP server's origin for an RFC 9728 .well-known/oauth-protected-resource document and return either the parsed metadata or a typed unavailability reason. Runs server-side under guardian.Policy so production resource servers without CORS can still be inspected.
   */
  async discoverProtectedResourceMetadata(
    request: DiscoverRemoteMcpProtectedResourceMetadataRequest,
    security?: DiscoverRemoteMcpProtectedResourceMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ProtectedResourceMetadataDiscovery> {
    return unwrapAsync(remoteMcpDiscoverProtectedResourceMetadata(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServer remoteMcp
   *
   * @remarks
   * Get a remote MCP server by ID or slug. Exactly one of id or slug must be provided.
   */
  async getServer(
    request?: GetRemoteMcpServerRequest | undefined,
    security?: GetRemoteMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServer> {
    return unwrapAsync(remoteMcpGetServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServerHeader remoteMcp
   *
   * @remarks
   * Get a remote MCP server header by ID
   */
  async getServerHeader(
    request: GetRemoteMcpServerHeaderRequest,
    security?: GetRemoteMcpServerHeaderSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServerHeader> {
    return unwrapAsync(remoteMcpGetServerHeader(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServerScopes remoteMcp
   *
   * @remarks
   * Report the scope state of the protected resource a remote-backed MCP server's logins are for: the operator pin, which belongs to the protected resource and so is shared by every server in the project with the same upstream URL, the scopes the resource advertises and last challenged with, the organization's resource scope discovery flag, and what a login through each bound client would request now. Requires read access to the server only. Reads cached state only; never contacts the resource.
   */
  async getServerScopes(
    request: GetRemoteMcpServerScopesRequest,
    security?: GetRemoteMcpServerScopesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServerScopes> {
    return unwrapAsync(remoteMcpGetServerScopes(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listServerHeaders remoteMcp
   *
   * @remarks
   * List the headers configured for a remote MCP server
   */
  async listServerHeaders(
    request: ListRemoteMcpServerHeadersRequest,
    security?: ListRemoteMcpServerHeadersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListServerHeadersResult> {
    return unwrapAsync(remoteMcpListServerHeaders(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listServers remoteMcp
   *
   * @remarks
   * List all remote MCP servers for a project
   */
  async listServers(
    request?: ListRemoteMcpServersRequest | undefined,
    security?: ListRemoteMcpServersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListServersResult> {
    return unwrapAsync(remoteMcpListServers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * probeURL remoteMcp
   *
   * @remarks
   * Probe a candidate remote MCP server URL by issuing an MCP initialize request and reporting whether MCP is available, authentication is required, the response is invalid, or the server is unreachable.
   */
  async probeURL(
    request: ProbeRemoteMcpURLRequest,
    security?: ProbeRemoteMcpURLSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ProbeURLResult> {
    return unwrapAsync(remoteMcpProbeURL(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setServerScopePin remoteMcp
   *
   * @remarks
   * Pin the scopes logins to a remote-backed MCP server's protected resource request, or clear the pin with an empty list. The pin belongs to the protected resource, so it applies to every server in the project with the same upstream URL, and the caller needs write access to all of them. Returns the scope state re-read after the write.
   */
  async setServerScopePin(
    request: SetRemoteMcpServerScopePinRequest,
    security?: SetRemoteMcpServerScopePinSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServerScopes> {
    return unwrapAsync(remoteMcpSetServerScopePin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateServer remoteMcp
   *
   * @remarks
   * Update a remote MCP server
   */
  async updateServer(
    request: UpdateRemoteMcpServerRequest,
    security?: UpdateRemoteMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServer> {
    return unwrapAsync(remoteMcpUpdateServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateServerHeader remoteMcp
   *
   * @remarks
   * Update a remote MCP server header
   */
  async updateServerHeader(
    request: UpdateRemoteMcpServerHeaderRequest,
    security?: UpdateRemoteMcpServerHeaderSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteMcpServerHeader> {
    return unwrapAsync(remoteMcpUpdateServerHeader(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * verifyURL remoteMcp
   *
   * @remarks
   * Probe a candidate remote MCP server URL and return the legacy boolean verification result.
   *
   * Deprecated: use probeURL instead.
   *
   * @deprecated method: This will be removed in a future release, please migrate away from it as soon as possible.
   */
  async verifyURL(
    request: VerifyRemoteMcpURLRequest,
    security?: VerifyRemoteMcpURLSecurity | undefined,
    options?: RequestOptions,
  ): Promise<VerifyURLResult> {
    return unwrapAsync(remoteMcpVerifyURL(
      this,
      request,
      security,
      options,
    ));
  }
}
